"use strict";Object.defineProperty(exports, "__esModule", {value: true});var broadcastMsgStatus; (function (broadcastMsgStatus) {
  const NOT_SCHEDULED = 'not_scheduled'; broadcastMsgStatus["NOT_SCHEDULED"] = NOT_SCHEDULED;
  const QUEUED = 'queued'; broadcastMsgStatus["QUEUED"] = QUEUED;
  const PROCESSING = 'processing'; broadcastMsgStatus["PROCESSING"] = PROCESSING;
  const COMPLETED = 'completed'; broadcastMsgStatus["COMPLETED"] = COMPLETED;
  const FAILED = 'failed'; broadcastMsgStatus["FAILED"] = FAILED;
  /* Held until the recipient replies YES to the consent request. */
  const AWAITING_CONSENT = 'awaiting_consent'; broadcastMsgStatus["AWAITING_CONSENT"] = AWAITING_CONSENT;
})(broadcastMsgStatus || (exports.broadcastMsgStatus = broadcastMsgStatus = {}));
